import { AbpHttpInterceptor, RefreshTokenService, AbpHttpConfigurationService } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Injector } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';

import { AxillaSharedServiceProxyModule } from '@axilla/axilla-shared';
import { OnlineHelperServiceProxyModule } from '@axilla/axilla-online-helper';

@NgModule({
    imports: [
        AxillaSharedServiceProxyModule,
        OnlineHelperServiceProxyModule
    ],
    providers: [
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.PayPalPaymentServiceProxy,
        ApiServiceProxies.StripePaymentServiceProxy,
        ApiServiceProxies.DashboardCustomizationServiceProxy,
        ApiServiceProxies.DocumentServiceProxy,
        ApiServiceProxies.DocumentStateServiceProxy,
        ApiServiceProxies.DocumentTypeServiceProxy,
        ApiServiceProxies.UblServiceProxy,
        ApiServiceProxies.ProjectServiceProxy,
        ApiServiceProxies.ApiConnectionSettingServiceProxy,
        ApiServiceProxies.ApiConfServiceProxy,
        ApiServiceProxies.ExactOnlineServiceProxy,
        ApiServiceProxies.AppServiceBaseServiceProxy,
        ApiServiceProxies.AppStoreServiceProxy,
        ApiServiceProxies.ChannelDefinitionServiceProxy,
        ApiServiceProxies.AppJobSchedulerServiceProxy,
        ApiServiceProxies.AppLoggerServiceProxy,
        ApiServiceProxies.LogDashboardServiceProxy,
        ApiServiceProxies.WorkFlowServiceProxy,
        ApiServiceProxies.ProcessorEngineLogServiceProxy,
        ApiServiceProxies.ProcessorDebugServiceProxy,
        ApiServiceProxies.OrderGuideServiceProxy,
        ApiServiceProxies.OrderHistoryServiceProxy,
        ApiServiceProxies.ArticleServiceProxy,
        ApiServiceProxies.SettingManagementServiceProxy,

        ApiServiceProxies.OrderServiceProxy,
        ApiServiceProxies.OrderScheduleServiceProxy,
        ApiServiceProxies.OrderStateServiceProxy,
        ApiServiceProxies.OrderScheduleStateServiceProxy,
        ApiServiceProxies.WebShopServiceProxy,
        ApiServiceProxies.MCOHealthServiceProxy,
        ApiServiceProxies.VDBServiceProxy,
        ApiServiceProxies.VirtualBankServiceProxy,
        ApiServiceProxies.CategoryServiceProxy,
        ApiServiceProxies.FavoriteArticlesServiceProxy,
        ApiServiceProxies.OnlineHelperServiceProxy,

        { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        {
            provide: HTTP_INTERCEPTORS,
            deps: [Injector],
            multi: true,
            useFactory: function (injector: Injector) {
                const configuration = injector.get(ZeroTemplateHttpConfigurationService);
                return new AbpHttpInterceptor(configuration, injector);
            }
        }
    ]
})
export class ServiceProxyModule { }
